import React from 'react';
import classNames from 'classnames';

import styles from './FeatureBanner.module.scss';
import markImg from '../../assets/images/markA.png';
import markImg2x from '../../assets/images/markA@2x.png';
import Button from '../Button/Button';
import { ButtonAppearance } from '../ButtonBase/types';
import {
  DEFAULT_SUBJECT_GROUP_FEATURE_BANNER_PHRASE,
  SUBJECT_GROUP_FEATURE_BANNER_PHRASES,
} from '../../utilities/constants/subject-group';
import { useOpenSubscriptionPopup } from '../../hooks/popup/useOpenSubscriptionPopup';
import { dataLayerGA } from '../../services/analytics/dataLayerGa';

interface Props {
  subjectGroup?: string;
}

const FeatureBanner: React.FC<Props> = ({ subjectGroup }) => {
  const phrase =
    (subjectGroup && SUBJECT_GROUP_FEATURE_BANNER_PHRASES[subjectGroup]) ||
    DEFAULT_SUBJECT_GROUP_FEATURE_BANNER_PHRASE;

  const { handleOpenSubscriptionPopup } = useOpenSubscriptionPopup();

  const handleClickButton = () => {
    handleOpenSubscriptionPopup();

    dataLayerGA.featureBannerClick(subjectGroup);
  };

  return (
    <div
      className={classNames(styles.featureBannerContent, 'd-flex flex-ai-c')}>
      <img
        src={markImg}
        alt='Mark-A'
        srcSet={`${markImg2x} 2x`}
      />

      <p className='text-md text-xl@md c-white fw-bold ta-center ta-left@md'>
        {phrase.text}
      </p>

      <Button
        appearance={ButtonAppearance.WHITE}
        className='c-primary-accent w-100 w-auto@md'
        onClick={handleClickButton}>
        Unlock {phrase.cta} →
      </Button>
    </div>
  );
};

export default FeatureBanner;
